module.exports = __webpack_public_path__ + "42fb305aa0e6d3ecfd27df997beaf4cb.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/mexe.png
// module id = 611
// module chunks = 0